import LocalTopSideFacets from '../../../../../../components/Blocks/Search/TopSideFacets';

const TopSideFacets = (props) => {
  return <LocalTopSideFacets {...props} />;
};

export default TopSideFacets;
